const truthyValues = new Set(['1', 'true', 'yes', 'on'])
const falsyValues = new Set(['0', 'false', 'no', 'off'])

function normalize(value) {
    if (value == null) return null
    const trimmed = String(value).trim()
    if (!trimmed) return ''
    return trimmed.toLowerCase()
}

export function getBooleanEnv(value, defaultValue = true) {
    const normalized = normalize(value)
    if (normalized === null) {
        return defaultValue
    }
    if (truthyValues.has(normalized)) {
        return true
    }
    if (falsyValues.has(normalized) || normalized === '') {
        return false
    }
    return defaultValue
}

export const TRACKING_ENABLED = getBooleanEnv(import.meta.env.VITE_GOOGLE_META_TRACKING, true)
export const GOOGLE_ADS_ID = String(import.meta.env.VITE_GOOGLE_ADS_ID || '').trim()
export const GOOGLE_ADS_INITIATE_CHECKOUT_LABEL = String(
    import.meta.env.VITE_GOOGLE_ADS_INITIATE_CHECKOUT_LABEL || 'uDtxCNKZsLkbEMzn5r9B'
).trim()
export const GOOGLE_ADS_PURCHASE_LABEL = String(
    import.meta.env.VITE_GOOGLE_ADS_PURCHASE_LABEL || 'fJ-pCMmpprkbEMzn5r9B'
).trim()
export const META_PIXEL_ID = String(import.meta.env.VITE_META_PIXEL_ID || '').trim()
export const BEMOBI_SMART_CHECKOUT_BASE_URL = String(
    import.meta.env.VITE_BEMOBI_SMART_CHECKOUT_BASE_URL || 'https://smart-checkout.bemobi.com/checkout'
).trim()
